import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import {
  Field,
  LENGTH_GIIN,
  LENGTH_LEI,
} from '../../../forms/identificationNumbersForm';

export const IdentificationNumbersSection = () => {
  const { t } = useTranslation();

  return (
    <Section
      datax="identificationNumbersSection"
      title={t('client.legal.identificationNumbers.title')}
    >
      <GridFields>
        <Field.Text
          fullWidth
          label={t('client.legal.identificationNumbers.LEI.label')}
          maxLength={LENGTH_LEI}
          name="identificationNumbers.LEI"
          placeholder={t('client.legal.identificationNumbers.LEI.placeholder')}
        />
        <Field.Text
          fullWidth
          label={t('client.legal.identificationNumbers.GIIN.label')}
          maxLength={LENGTH_GIIN}
          name="identificationNumbers.GIIN"
          placeholder={t('client.legal.identificationNumbers.GIIN.placeholder')}
        />
      </GridFields>
    </Section>
  );
};
